export default function Factor({ factor }) {
  return factor && <div className={'button__factor custom-button__factor'}>{`×${factor}`}</div>;
}
